import React, {  Component } from 'react';
import { connect } from 'react-redux';

class DoNotDeliverySelectedAddressOverlayDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            showDialog: false
        }
    }

    closeDialog(event) {
        event.preventDefault();
        this.setState({
            showDialog: false
        });
		this.props.handleDialog && this.props.handleDialog('DoNotDeliverySelectedAddressOverlayDialog', false);
    }

    componentDidMount() {
		// window.scrollTo(0, 0);
        this.setState({
            showDialog: this.props.showDialog
        });
    }

    render() {
        return (
            <div className={"overlayDialog "+(this.state.showDialog?"visible":"hide")} id="confirmApproveRequestDialog">
                <div className="blackoutLayer"></div>
                <div className="overlayDialogWindow" style={{top: 122}}>
                    <h2 className="title">Shipping Address</h2>
                    <p>Please check the shipping address. We do not deliver to the selected address.</p>
                    <a className="blueButton yesButton" onClick={this.closeDialog.bind(this)}>Ok</a>
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
	return { state };
};

DoNotDeliverySelectedAddressOverlayDialog = connect(mapStateToProps)(DoNotDeliverySelectedAddressOverlayDialog);
export default DoNotDeliverySelectedAddressOverlayDialog;



// WEBPACK FOOTER //
// ./src/App/components/dialogs/doNotDeliverySelectedAddressOverlayDialog.js